exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vtl .vtl-drag-disabled[data-v-4b48937a] {\n  background-color: #d0cfcf;\n}\n.vtl .vtl-drag-disabled[data-v-4b48937a]:hover {\n  background-color: #d0cfcf;\n}\n.vtl .vtl-disabled[data-v-4b48937a] {\n  background-color: #d0cfcf;\n}\n.icon[data-v-4b48937a]:hover {\n  cursor: pointer;\n}", ""]);

// exports
